import { DsResetPasswordInterface } from '../interfaces/ds-reset-password.interface';

export class DsResetPassword {
  /**
   * The user token
   */
  token: string;

  /**
   * The user password
   */
  password: string;

  /**
   * Creates an instance of DsResetPassword.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsResetPasswordInterface) {
    this.token = jsonData.token;
    this.password = jsonData.password;
  }
}
